import React from "react";

const PurpleTopLeftGradient = ({ className }) => {
  return (
    <svg
      width="360"
      height="341"
      viewBox="0 0 360 341"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g filter="url(#filter0_f_6343_14352)">
        <rect
          width="462"
          height="462"
          rx="231"
          transform="matrix(1 0 0 -1 -251 101)"
          fill="#9100FF"
          fillOpacity="0.64"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_6343_14352"
          x="-491"
          y="-601"
          width="942"
          height="942"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="120"
            result="effect1_foregroundBlur_6343_14352"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PurpleTopLeftGradient;
